import React from 'react'
import { Link, useLocation } from 'react-router-dom';
import logoblack from "../../../assets/logo/Fichier 1@2x.png";
import gradient from "../../assets/ς๏l๏г ๓y ฬ๏гld ☛gгƹƹภ☚.jpeg"

const Sidebar = () => {
    const location = useLocation()

    const menuItems = [
      { name: 'Tableau de bord', icon: 'home', path: '/mira-lenta' },
      { name: 'Mes candidatures', icon: 'calendar', path: '/mira-lenta/candidature' },
      { name: 'Mes enregistrements', icon: 'users', path: '/mira-lenta/enregistrement' },
      { name: 'Mon CV', icon: 'services', path: '/mira-lenta/cv' },
      // { name: 'Paramètre', icon: 'abonnement', path: '/pro/abonnement' },
      { name: 'Paramètres', icon: 'parameter', path: '/mira-lenta/parametre'},
    ]

    const isActive = (path) => {
      if (path === location.pathname) {
        return true;
      }
      return false;
    }
  
    return (
      <div className="min-h-screen  flex-col w-64 flex-shrink-0 antialiased  hidden lg:flex  lg:ml-6   xl:ml-40 mt-">
        <div className="fixed flex flex-col top-0 left-0 w-64 bg-white h-full border-r  lg:ml-6  xl:ml-40 mt-14">
          <div className="overflow-y-auto overflow-x-hidden flex-grow">
            <ul className="flex flex-col py-4 space-y-1 font-medium">
              <li className="px-5">
                <div className="flex flex-row items-center h-8">
                </div>
              </li>
              {menuItems.map((item, index) => (
                <li key={index}>
                  {/* {console.log(item.path , location.pathname)} */}
                  <Link
                to={item.path}
                className={`relative flex flex-row items-center h-11 focus:outline-none hover:bg-primary hover:bg-opacity-5 text-gray-600 hover:text-primary hover:font-medium border-r-4 ${
              
                  location.pathname === item.path ? ' border-r-[4px] border-r-[#ff953e] bg-primary bg-opacity-5 text-primary ' : ' border-transparent '
              
                } pr-6 border-r-4 border-r-transparent `}
              >
              <div className= {`h-5 w-[3px]  rounded-md ${
                          isActive(item.path)
                            ? "bg-primary-green"
                            : "bg-none"
                          }`}
                        ></div>
                    <div className=
                    {`inline-flex justify-center items-center ml-2  p-1  rounded-md ${
                      isActive(item.path)
                        ? "bg-primary-green text-[#005934]"
                        : "bg-none text-gray-600"
                      }`}
                    >
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                       
   
    {item.icon === 'home' && (
    <path d="M3 16.5L12 21.75L21 16.5" stroke="#005934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>  )}

    {item.icon === 'home' && (
    <path d="M3 12L12 17.25L21 12" stroke="#005934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>   )}

    {item.icon === 'home' && (
    <path d="M3 7.5L12 12.75L21 7.5L12 2.25L3 7.5Z" stroke="#005934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>   )}



          {
          item.icon === 'calendar' && (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.251 6.75H3.75098C3.33676 6.75 3.00098 7.08579 3.00098 7.5V19.5C3.00098 19.9142 3.33676 20.25 3.75098 20.25H20.251C20.6652 20.25 21.001 19.9142 21.001 19.5V7.5C21.001 7.08579 20.6652 6.75 20.251 6.75Z" stroke="#767F8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15.75 6.75V5.25C15.75 4.85218 15.592 4.47064 15.3107 4.18934C15.0294 3.90804 14.6478 3.75 14.25 3.75H9.75C9.35218 3.75 8.97064 3.90804 8.68934 4.18934C8.40804 4.47064 8.25 4.85218 8.25 5.25V6.75" stroke="#767F8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21.0011 11.8415C18.2658 13.424 15.1605 14.255 12.0004 14.25C8.84075 14.255 5.736 13.4243 3.00098 11.8423" stroke="#767F8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.875 11.25H13.125" stroke="#767F8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            )}
              {item.icon === 'availability' && (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 8h14M12 4v4m0 8v4m-8-4h16"
                />
              )}
              {item.icon === 'users' && (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 21L11.9993 17.25L6 21V4.5C6 4.30109 6.07902 4.11032 6.21967 3.96967C6.36032 3.82902 6.55109 3.75 6.75 3.75H17.25C17.4489 3.75 17.6397 3.82902 17.7803 3.96967C17.921 4.11032 18 4.30109 18 4.5V21Z" stroke="#767F8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              
              )}
              {item.icon === 'services' && (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 21L11.9993 17.25L6 21V4.5C6 4.30109 6.07902 4.11032 6.21967 3.96967C6.36032 3.82902 6.55109 3.75 6.75 3.75H17.25C17.4489 3.75 17.6397 3.82902 17.7803 3.96967C17.921 4.11032 18 4.30109 18 4.5V21Z" stroke="#767F8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              
              )}

              {item.icon === 'parameter' && (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z" stroke="#767F8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.5193 4.13943L9.75029 2.81306C9.65538 2.74166 9.54485 2.69384 9.42783 2.67353C9.31081 2.65323 9.19063 2.66103 9.07721 2.69628C8.52933 2.86785 7.99779 3.08777 7.48885 3.35346C7.38349 3.40872 7.29279 3.48824 7.22422 3.58547C7.15566 3.68269 7.1112 3.79483 7.09452 3.91262L6.78179 6.10177C6.66259 6.20743 6.54589 6.31733 6.43169 6.43147C6.31752 6.54563 6.2076 6.66237 6.10191 6.78166L6.10186 6.7817L3.9131 7.0947C3.7955 7.11133 3.68353 7.15567 3.58642 7.22406C3.48932 7.29245 3.40986 7.38294 3.35459 7.48807C3.08849 7.99679 2.86814 8.52816 2.69613 9.07591C2.66071 9.18948 2.65281 9.30985 2.67307 9.42708C2.69334 9.54431 2.7412 9.65504 2.81269 9.75013L4.13952 11.5192C4.12995 11.6782 4.12514 11.8385 4.12509 11.9999C4.12509 12.1614 4.1299 12.3216 4.13953 12.4807L4.13952 12.4808L2.81315 14.2498C2.74175 14.3447 2.69393 14.4552 2.67363 14.5723C2.65332 14.6893 2.66112 14.8095 2.69638 14.9229C2.86794 15.4708 3.08787 16.0023 3.35355 16.5112C3.40881 16.6166 3.48834 16.7073 3.58556 16.7759C3.68278 16.8444 3.79492 16.8889 3.91271 16.9056L6.10186 17.2183C6.20752 17.3375 6.31742 17.4542 6.43156 17.5684C6.54572 17.6826 6.66245 17.7925 6.78175 17.8982L6.78179 17.8982L7.09479 20.087C7.11142 20.2046 7.15575 20.3166 7.22415 20.4137C7.29254 20.5108 7.38303 20.5902 7.48816 20.6455C7.99688 20.9116 8.52825 21.1319 9.07599 21.304C9.18957 21.3394 9.30994 21.3473 9.42717 21.327C9.5444 21.3067 9.65512 21.2589 9.75021 21.1874L11.5193 19.8606C11.6783 19.8701 11.8385 19.875 12 19.875C12.1614 19.875 12.3217 19.8702 12.4808 19.8606L12.4809 19.8606L14.2499 21.1869C14.3448 21.2583 14.4553 21.3062 14.5724 21.3265C14.6894 21.3468 14.8095 21.339 14.923 21.3037C15.4708 21.1321 16.0024 20.9122 16.5113 20.6465C16.6167 20.5913 16.7074 20.5118 16.776 20.4145C16.8445 20.3173 16.889 20.2052 16.9057 20.0874L17.2184 17.8982C17.3376 17.7926 17.4543 17.6827 17.5685 17.5685C17.6827 17.4544 17.7926 17.3376 17.8983 17.2183L17.8983 17.2183L20.0871 16.9053C20.2047 16.8887 20.3167 16.8443 20.4138 16.7759C20.5109 16.7076 20.5903 16.6171 20.6456 16.5119C20.9117 16.0032 21.132 15.4718 21.304 14.9241C21.3395 14.8105 21.3474 14.6902 21.3271 14.5729C21.3068 14.4557 21.259 14.345 21.1875 14.2499L19.8607 12.4808C19.8702 12.3218 19.875 12.1616 19.8751 12.0001C19.8751 11.8386 19.8703 11.6784 19.8607 11.5193L19.8607 11.5192L21.187 9.7502C21.2584 9.65529 21.3063 9.54476 21.3266 9.42774C21.3469 9.31071 21.3391 9.19054 21.3038 9.07712C21.1322 8.52924 20.9123 7.99769 20.6466 7.48875C20.5914 7.3834 20.5118 7.2927 20.4146 7.22413C20.3174 7.15557 20.2053 7.11111 20.0875 7.09442L17.8983 6.7817C17.7927 6.6625 17.6828 6.5458 17.5686 6.4316C17.4545 6.31743 17.3377 6.20751 17.2184 6.10182L17.2184 6.10177L16.9054 3.91301C16.8888 3.79541 16.8444 3.68344 16.776 3.58633C16.7076 3.48923 16.6172 3.40976 16.512 3.35449C16.0033 3.0884 15.4719 2.86805 14.9242 2.69604C14.8106 2.66062 14.6902 2.65272 14.573 2.67298C14.4558 2.69325 14.3451 2.7411 14.25 2.8126L12.4809 4.13943C12.3219 4.12985 12.1616 4.12504 12.0002 4.125C11.8387 4.125 11.6785 4.12981 11.5194 4.13944L11.5193 4.13943Z" stroke="#767F8C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
              )}
  
  
                      </svg>
                    </div>
                    <span className=
                    {`ml-2 text-sm tracking-wide truncate ${
                      isActive(item.path)
                        ? " text-primary-black"
                        : " text-gray-600"
                      }`}
                    >{item.name}</span>
                  </Link>
                </li>
              ))}
            </ul>

            <div className="relative h-[280px] max-w-sm mr-4 mx-auto mt-10 px-5 py-8 group rounded-lg bg-gray-200 overflow-hidden shadow-xl">
              <img src={gradient} alt="" className="absolute w-full h-full inset-0 object-cover"/>
              <div
                  className="absolute inset-0 w-full h-full rounded-lg bg-black  transition duration-500 backdrop-filter bg-opacity-20 ">
                  {/* // className="absolute inset-0 w-full h-full rounded-lg  transition duration-500 bg-opacity-20 "> */}
              </div>
              <div className="absolute inset-x-3 text-white">
                  <h2 className="text-2xl font-semibold mb-2">Standard</h2>
                  <p className="text-sm font-medium uppercase tracking-wider mb-6">Gratuit</p>
                  <p className=" block text-sm">Whether you're looking to save money spending abroad or sticking to
                      your
                      budget with our built-in budgeting.</p>
              </div>
              <button className="absolute inset-x-5 bottom-8 py-3 rounded-lg font-semibold bg-white shadow-lg  transition duration-200 hover:bg-primary-green hover:text-emerald-900 block">Choisir</button>
            </div>
            
          </div>
        </div>
      </div>
    );
  };

export default Sidebar